export const convertToImageURL = (
  imageSrc: string | undefined,
  type: 'dashboard' | 'viewPack' | 'widget',
): string => {
  try {
    if (!imageSrc) {
      throw new Error('image src not exist');
    }

    if (imageSrc.startsWith('data:image/')) {
      return imageSrc;
    }

    return new URL(imageSrc, import.meta.url)?.href;
  } catch {
    return new URL(`/src/common/assets/widgets/${type}-default.png`, import.meta.url)?.href;
  }
};
